import { RouteObject } from "react-router";

import * as Sentry from "@sentry/react";

import PageError from "@/helpers/components/Errors/PageError";

export const NodeDiagramRoutes: RouteObject = {
	path: "nodediagram/*",
	errorElement: () => <div>Procedure diagram not found</div>,

	children: [
		{
			index: true,
			path: "list",
			lazy: async () => {
				const { NodeDiagramTemplateList } = await import(
					"@/components/Procedures/NodeDiagramTemplateList"
				);
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<NodeDiagramTemplateList />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: "list/:id",
			lazy: async () => {
				const { NodeDiagramTemplateList } = await import(
					"@/components/Procedures/NodeDiagramTemplateList"
				);
				return {
					Component: () => (
						<Sentry.ErrorBoundary
							fallback={({ error, componentStack, resetError }) => (
								<PageError
									error={error}
									componentStack={componentStack}
									reset={resetError}
								/>
							)}
						>
							<NodeDiagramTemplateList />
						</Sentry.ErrorBoundary>
					),
				};
			},
		},
		{
			path: ":nodeid/edit/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { EditNodeDiagramTemplate } = await import(
							"@/components/Procedures/EditNodeDiagramTemplate"
						);
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={({ error, componentStack, resetError }) => (
										<PageError
											error={error}
											componentStack={componentStack}
											reset={resetError}
										/>
									)}
								>
									<EditNodeDiagramTemplate />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
				{
					path: ":id",
					lazy: async () => {
						const { EditNodeDiagramTemplate } = await import(
							"@/components/Procedures/EditNodeDiagramTemplate"
						);
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={({ error, componentStack, resetError }) => (
										<PageError
											error={error}
											componentStack={componentStack}
											reset={resetError}
										/>
									)}
								>
									<EditNodeDiagramTemplate />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
			],
		},
		{
			path: "new/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { CreateNodeDiagramTemplate } = await import(
							"@/components/Procedures/CreateNodeDiagramTemplate"
						);
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={({ error, componentStack, resetError }) => (
										<PageError
											error={error}
											componentStack={componentStack}
											reset={resetError}
										/>
									)}
								>
									<CreateNodeDiagramTemplate />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
				{
					path: ":id",
					lazy: async () => {
						const { CreateNodeDiagramTemplate } = await import(
							"@/components/Procedures/CreateNodeDiagramTemplate"
						);
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={({ error, componentStack, resetError }) => (
										<PageError
											error={error}
											componentStack={componentStack}
											reset={resetError}
										/>
									)}
								>
									<CreateNodeDiagramTemplate />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
			],
		},
	],
};
